import { useEtapaDestinoTransferencia } from "./use-etapa-destino-transferencia";
import { EtapaDestinoTransferenciaView } from "./view-etapa-destino-transferencia";
import type { EtapaDestinoTransferenciaProps } from "./types-etapa-destino-transferencia";

export function EtapaDestinoTransferencia(props: EtapaDestinoTransferenciaProps) {
  const vm = useEtapaDestinoTransferencia(props);

  return <EtapaDestinoTransferenciaView {...vm} />;
}

export type * from "./types-etapa-destino-transferencia";
